export default __webpack_public_path__ + "static/media/cif-nl.226e23fd.svg";